import React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { useCanary } from '@bill/canary.react'
import { FormattedMessage } from '@divvy-web/i18n'
import BasicButton, { BASIC_BUTTON_TYPE_FLAT } from '@divvy-web/skylab.basicbutton'

import useBdcOrgID from '@sputnik/hooks/useBdcOrgID'
import { ADVANCED_ONBOARDING, PATHNAME_CONSTS } from '@sputnik/resources/constants'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'
import { navigateToBillSetup } from '@sputnik/utils/billUtils'
import { getReturnFlowLocalStorage } from '@sputnik/utils/neoRedirectUtils'

const SaveAndExitButton = () => {
  const navigate = useNavigate()
  const { appId } = useParams()
  const { search } = useLocation()
  const { track } = useWebTracking()

  const isAdvancedOnboardingReturnEnabled = useCanary('advanced-onboarding-return-flow')
  const [bdcOrgId, { loading }] = useBdcOrgID()

  const shouldRouteToBdc =
    getReturnFlowLocalStorage() === ADVANCED_ONBOARDING && bdcOrgId && isAdvancedOnboardingReturnEnabled

  const onClickSaveAndExit = () => {
    track('se_signup__left_nav_save_and_exit__fired')
    if (shouldRouteToBdc) {
      navigateToBillSetup(bdcOrgId, appId)
    } else {
      navigate({
        pathname: PATHNAME_CONSTS.DASHBOARD_PATH,
        search,
      })
    }
  }

  return (
    <BasicButton
      disabled={loading}
      type={BASIC_BUTTON_TYPE_FLAT}
      onClick={onClickSaveAndExit}
    >
      <FormattedMessage
        defaultMessage='Save and exit'
        id='sputnik.SaveAndExitButton__afFDir'
      />
    </BasicButton>
  )
}

export default SaveAndExitButton
